<template>
  <div class="screen-component-title" :style="titleStyle" role="heading" aria-level="2" :aria-label="settings.text">
    <span v-if="settings.showMarker" class="screen-component-title__marker" aria-hidden="true" />
    <strong class="screen-component-title__text" :title="settings.text">{{ settings.text }}</strong>
  </div>
</template>
<script>
import { componentTitleSettings, componentTitleStyle } from './presentation'

export default {
  name: 'avue-echart-componentTitle', inheritAttrs: false,
  props: { option: { type: Object, default: () => ({}) } },
  computed: {
    settings () { return componentTitleSettings(this.option) },
    titleStyle () { return componentTitleStyle(this.option) }
  }
}
</script>
<style scoped>
.screen-component-title { display: flex; align-items: center; width: 100%; height: 100%; box-sizing: border-box; min-width: 0; min-height: 0; overflow: hidden; }
.screen-component-title__marker { flex-shrink: 0; width: var(--component-title-marker-width); height: 1em; max-height: 100%; margin-right: var(--component-title-marker-gap); background: var(--component-title-marker); }
.screen-component-title__text { min-width: 0; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 1em; line-height: 1.3; font-weight: inherit; }
</style>
